


































import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'PagePagination',
  props: {
    numberOfPages: Number,
    page: Number,
  },
  setup(_props, { emit }) {
    const changePage = (page: number) => {
      emit('update:page', page)
    }

    return {
      changePage,
    }
  },
})
